export default __webpack_public_path__ + "media/sierra.6f69c5db.jpg";